import { ICreateDodatnuUplatuRacunaCommand, IDodatneUplateInfoDto, ITipTransakcijeDto, ITipTransakcijeUplataDto, TipTransakcije } from './../../../../../../data-api/src/lib/eKompanija-api';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IRacunInfoDto, VezaniRacunDto } from '@kodit/core/data-api';
import { FormBuilderTypeSafe, FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root',
})
export class RacunInfoService {
  constructor(
    private _fb: FormBuilderTypeSafe
  ) {}

  racunInfoDto$ = new BehaviorSubject<IRacunInfoDto>(null);

  private vezaniRacuni$ = new BehaviorSubject<VezaniRacunDto[]>([]);

  get getRacunInfoDto() {
    return this.racunInfoDto$.asObservable();
  }

  set setRacunInfoDto(data: IRacunInfoDto) {
    this.racunInfoDto$.next(data);
  }

  get getVezaneRacune() {
    return this.racunInfoDto$.value.vezaniRacuniDto;
  }

  reloadDocuments$ = new BehaviorSubject<number | undefined>(undefined);
  get getReloadedDocuments() {
    return this.reloadDocuments$.asObservable();
  }
  set setReloadDocuments(racunId: number) {
    this.reloadDocuments$.next(racunId);
  }

  racunId$ = new BehaviorSubject<number>(null);
  get getRacunId() {
    return this.racunId$.asObservable();
  }
  set setRacunId(data: number) {
    this.racunId$.next(data);
  }

  get getVezaniRacuni(){
    return this.vezaniRacuni$.asObservable();
  }

  get getVezaniRacuniValue(){
    return this.vezaniRacuni$.value;
  }

  set setVezaniRacuni(data: VezaniRacunDto[]){
    this.vezaniRacuni$.next(data);
  }

  vezaniRacuniChanged$ = new BehaviorSubject<boolean>(false);

  set setVezaniRacuniChanged(value: boolean) {
    this.vezaniRacuniChanged$.next(value);
  }

  get getVezaniRacuniChanged() {
    return this.vezaniRacuniChanged$.asObservable();
  }

  public GetDodatnaUplataFormGroup(model?: ICreateDodatnuUplatuRacunaCommand): FormGroupTypeSafe<ICreateDodatnuUplatuRacunaCommand> {
    return this._fb.group<ICreateDodatnuUplatuRacunaCommand>({
      id: new FormControl(model?.id),
      iznosUplate: new FormControl(model?.iznosUplate),
      tipTransakcije: new FormControl(model?.tipTransakcije ?? TipTransakcije.PROVIZIJA_BANKE)
    });
  }

}
